exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".graphql-playground .jKPMJV, .graphql-playground .kOowTR, .graphql-playground .loHTNh:last-child {\n    display: none\n}\n\n.graphql-playground .RziiU {\n    height: 800px;\n}\n\n.graphql-playground .fTlHyO {\n    height: 80px;\n}\n\n\n", ""]);
